// Longest request an advisor can give Cleo for a message they are writing
// themselves (CL-2217). Shared so the input box and the callable agree on it;
// the Cleo graph enforces its own, looser cap as a backstop for other callers.
export const MAX_COMPOSE_INSTRUCTIONS_LENGTH = 1000
